import { gql } from '@apollo/client'

export const MFA_VERIFY = gql`
  mutation userMfaVerify($token: String!) {
    userMfaVerify(token: $token) {
      result {
        message,
        status
      },
      token
    }
  }
`

export interface MFAVerifyVariables {
  token: string
}

export interface MFAVerifyResult {
  userMfaVerify: {
    result: {
      message: string,
      status: string
    },
    token: string
  }
}

export const MFA_RESEND = gql`
  mutation userMfaResend {
    userMfaResend {
      result {
        message,
        status
      }
    }
  }
`

export interface MFAResendResult {
  userMfaResend: {
    result: {
      message: string,
      status: string
    }
  }
}
